<template>
  <!--
  Forked from:
  https://quasar.dev/vue-components/list-and-list-items#example--left-avatar-thumbnail-qitemsection
-->
  <q-dialog v-model="this.noteModalVisible" transition-show="rotate" transition-hide="rotate">
    <q-card class="bg-teal text-white" style="width: 100%">
      <q-card-section class="q-pt-none">
        <q-form
            class="padding-sm"
            @submit="submitNote"
            @reset="closeNoteModal">
          <q-item>
            <q-input
                filled
                v-model="this.note"
                label="Note"
                type="textarea"
                lazy-rules
                :rules="[val => val.length > 0 || 'Please enter a note']"
            ></q-input>
          </q-item>
        </q-form>
      </q-card-section>

      <q-card-actions align="right" class="bg-white text-teal">
        <q-btn label="Cancel" @click="closeNoteModal()" type="submit" color="secondary"></q-btn>
        <q-btn label="Done" @click="submitNote()" type="submit" color="primary"></q-btn>
      </q-card-actions>

    </q-card>
  </q-dialog>
  <div id="q-app" style="min-height: 100vh;">
    <div class="q-pa-md" style="max-width: 350px">
        <div :key="render_table">
          <div v-if="this.tab===1">
              <CaseBasic @reload="syncData();" :returned_cases="this.returned_cases"></CaseBasic>
          </div>
          <div v-if="this.tab===2">
            <CasePoi @reload="syncData();" :returned_cases="this.returned_cases"></CasePoi>
          </div>
          <div v-if="this.tab===3">
            <CaseNotes @reload="syncData();" @addNote="showNoteModal()" :returned_cases="this.returned_cases"></CaseNotes>
          </div>
          <div v-if="this.tab===4">
            <CaseAttachments @camera_open="this.camera_open = true" @camera_close="this.camera_open = false" :returned_cases="this.returned_cases"></CaseAttachments>
          </div>
          <div v-if="this.tab===5">
            <CaseMessages @reload="syncData();" :returned_cases="this.returned_cases"></CaseMessages>
          </div>
            <q-footer v-if="!this.camera_open">
              <q-toolbar>
                <q-btn class="bg-grey-8" @click="changeTab(1)">
                  Case
                </q-btn>
                <q-btn class="bg-blue-8"  @click="changeTab(2)">
                  Poi
                </q-btn>
                <q-btn class="bg-green-5" @click="changeTab(3)">
                  Notes
                </q-btn>
                <q-btn class="bg-purple-5"  @click="changeTab(4)">
                  Attachments
                </q-btn>
              </q-toolbar>
              <q-toolbar>
                <q-btn class="bg-red-5" @click="changeTab(5)">
                  Messages
                </q-btn>
              </q-toolbar>
            </q-footer>
        </div>
    </div>
  </div>

</template>


<script>
import axios from 'axios'
import { useRouter } from 'vue-router'
import CaseBasic from "@/views/Case/CaseBasic.vue";
import CaseAttachments from "@/views/Case/CaseAttachments.vue";
import CasePoi from "@/views/Case/CasePoi.vue";
import {Notify} from "quasar";
import CaseNotes from "@/views/Case/CaseNotes.vue";
import CaseMessages from "@/views/Case/CaseMessages.vue";
export default {
  name: 'OpenCasesPage',
  components:{
    CaseBasic,
    CaseMessages,
    CaseAttachments,
    CasePoi,
    CaseNotes
  },
  setup(){
    return {
    }
  },
  data(){
    return {
      camera_open : false,
      noteModalVisible : false,
      returned_cases : [],
      render_table : null,
      current_user : null,
      reload_notes : 0,
      tab : 1,
      note: null,
      users : null

    }
  },
  mounted(){
    this.syncData();
  },
  computed:{
    user_id(){
      return this.$store.getters.user_id;
    }
  },
  methods : {
    changeTab(tab){
      this.tab = tab;
    },
    submitNote(){
      let notable_id = this.$route.params.id;
      let notable_type = 'App\\Models\\Docket';
      let content = this.note;
      axios.post(this.$store.getters.url+'/api/api-notes',{
        notable_id: notable_id,
        notable_type: notable_type,
        content: content
      })
      .then(() => {
        Notify.create({
          progress: true,
          timeout: 1000,
          position: 'center',
          color: 'green-4',
          textColor: 'white',
          icon: 'cloud_done',
          message: 'Note Added !! '
        })
        this.reload_notes = 1;
        this.changeTab(3);
      })
      .catch(() => {
      }).finally(() => {
        this.note = null;
        this.syncData();
      });

      this.noteModalVisible = false;
    },
    closeNoteModal(){
      this.noteModalVisible = false;
    },
    showNoteModal(){
      this.noteModalVisible = true;
    },
    getUsers(){
      axios.get(this.$store.getters.url+'/api/api-users')
          .then((res) => {
            this.users = res.data.data;
          })
          .catch(() => {
          }).finally(() => {
          });
    },

    async syncData(){
      const router = useRouter()
      let token = this.$store.getters.token;
      if( token ){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      }else{
        router.push({ name: "login"})
      }
        axios.get(this.$store.getters.url+'/api/api-dockets/'+this.$route.params.id)
            .then((res) => {
              // eslint-disable-next-line no-unreachable
              Notify.create({
                progress: true,
                timeout: 1000,
                position: 'center',
                color: 'green-4',
                textColor: 'white',
                icon: 'cloud_done',
                message: 'Cases Retrieved !! '
              })
              this.returned_cases = res.data.docket;
              console.log(this.returned_cases);
              this.getUsers();
              this.render_table = true;
            })
            .catch((error) => {
              console.log(error)
              Notify.create({
                progress: true,
                timeout: 1000,
                position: 'center',
                color: 'red-5',
                textColor: 'white',
                icon: 'warning',
                message: 'Error retrieving tasks: '+error
              })
            }).finally(() => {
          //Perform action in always
        });
    },
  }
}
</script>
